import { render, staticRenderFns } from "./BasicCard.vue?vue&type=template&id=75076b70"
import script from "./BasicCard.vue?vue&type=script&lang=js"
export * from "./BasicCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports